/**
 * 创建一个 resize observer
 * 用于观察指定元素尺寸是否 reisze
 */
export function _createResizeObserver(callback, interval) {
    if (interval === void 0) { interval = 10; }
    var timer;
    var observer = new ResizeObserver(function (entries, observer) {
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback && callback(entries, observer);
        }, interval);
    });
    return observer;
}
export function createDomResizeObserver(dom, callback, interval) {
    if (interval === void 0) { interval = 10; }
    var observer = _createResizeObserver(function (entries, _observer) {
        Array.from(entries).forEach(function (entity) {
            var contentRect = entity.contentRect, target = entity.target;
            if (target && contentRect) {
                callback(entity);
            }
        });
    }, interval);
    observer.observe(dom);
    return observer;
}
//# sourceMappingURL=resize.js.map